module.exports = __webpack_public_path__ + "static/img/NR.1ae3ee9c.svg";